<template>
  <div>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headersValores"
          :items="itemValores"
          class="elevation-1 w-100 proposta"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.investimentoTotal="{ item }">
            {{
              item.investimentoTotal &&
              item.investimentoTotal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>

          <template v-slot:item.contrapartidaSebrae="{ item }">
            {{
              item.contrapartidaSebrae &&
              item.contrapartidaSebrae.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>

          <template v-slot:item.investimentoMunicipal="{ item }">
            {{
              item.investimentoMunicipal &&
              item.investimentoMunicipal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "TabelaValoresPropostaMA",
  props: {
    payload: { type: Object, required: true },
    faixa: { type: Object, default: null },
    combos: { type: Array, default: () => [] },
  },
  data() {
    return {
      headersValores: [
        { text: "", value: "combo", sortable: false },
        {
          text: "Investimento Total",
          value: "investimentoTotal",
          sortable: false,
        },
        {
          text: "Contrapartida Sebrae",
          value: "contrapartidaSebrae",
          sortable: false,
        },
        {
          text: "Investimento Municipal",
          value: "investimentoMunicipal",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    getSomaSolucoes() {
      return this.payload.solucoesFaixasDTO.reduce((partialSum, a) => {
        return partialSum + (a.precoFaixa || a.preco || 0);
      }, 0);
    },

    faixaSubsidioPreium() {
      return (this.faixa && this.faixa.subsidioPremium) || 0;
    },
    faixaSubsidio() {
      return (this.faixa && this.faixa.faixaSubsidio) || 0;
    },
    getValorTotal() {
      return this.getSomaSolucoes;
    },
    getValorContrapartidaSebrae() {
      const valorComSubsidio =
        this.getSomaSolucoes * (this.faixaSubsidio / 100);

      return valorComSubsidio;
    },
    getValorInvestimentoMunicipal() {
      const valorComSubsidio =
        this.getSomaSolucoes * ((100 - this.faixaSubsidioPreium) / 100);

      return valorComSubsidio;
    },

    itemValores() {
      let valores = [
        {
          combo: "Total",
          investimentoTotal: this.getValorTotal,
          contrapartidaSebrae: this.getValorContrapartidaSebrae,
          investimentoMunicipal: this.getValorInvestimentoMunicipal,
        },
      ];

      return valores;
    },
  },
};
</script>
